import { render, staticRenderFns } from "./PrivacyPolices.vue?vue&type=template&id=d9ab5c74"
import script from "./PrivacyPolices.vue?vue&type=script&lang=js"
export * from "./PrivacyPolices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports